import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Star, CheckCircle } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'María González, 42 años',
    location: 'Miami, FL',
    image: 'https://ui-avatars.com/api/?name=Maria+G&background=1B5E20&color=fff&size=128',
    quote: 'Llevaba años con inflamación y cansancio. En 3 semanas con el Gut Rest Program me siento como nueva. Mi digestión cambió completamente.'
  }, {
    name: 'Carlos Mendoza, 38 años',
    location: 'Houston, TX',
    image: 'https://ui-avatars.com/api/?name=Carlos+M&background=F9A825&color=fff&size=128',
    quote: 'El médico me dijo que tenía hígado graso. Empecé con el sistema completo y en 45 días mis análisis mejoraron. Lo recomiendo 100%.'
  }, {
    name: 'Ana Rodríguez, 35 años',
    location: 'Chicago, IL',
    image: 'https://ui-avatars.com/api/?name=Ana+R&background=4CAF50&color=fff&size=128',
    quote: 'Trabajo doble turno y siempre estaba agotada. El Youth Elixir y Flora Liv me dieron la energía que necesitaba. Mis hijos notan la diferencia.'
  }];
  return <section id="testimonios" className="py-24 bg-[#FAFAF7]" data-id="element-392">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-393">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-394">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif font-bold text-[#1A1A1A] mb-6" data-id="element-395">
            Lo Que Dicen Las Familias Latinas en USA
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="flex flex-col items-center justify-center mb-4" data-id="element-396">
            <div className="flex text-[#F9A825] mb-2" data-id="element-397">
              {[...Array(5)].map((_, i) => <Star key={i} size={24} fill="currentColor" data-id="element-398" />)}
            </div>
            <p className="text-xl font-bold text-[#1A1A1A]" data-id="element-399">4.9/5</p>
            <p className="text-gray-600" data-id="element-400">
              +2,000 personas ya transformaron su bienestar
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-401">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white rounded-3xl p-8 border border-gray-100 shadow-sm relative flex flex-col" data-id="element-402">
              <div className="flex text-[#F9A825] mb-6" data-id="element-403">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-404" />)}
              </div>

              <p className="text-gray-700 text-lg mb-8 italic flex-grow" data-id="element-405">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center justify-between mt-auto pt-6 border-t border-gray-50" data-id="element-406">
                <div className="flex items-center" data-id="element-407">
                  <img src={testimonial.image} alt={testimonial.name} loading="lazy" className="w-12 h-12 rounded-full mr-4" data-id="element-408" />
                  <div data-id="element-409">
                    <h4 className="font-bold text-[#1A1A1A] text-sm" data-id="element-410">
                      {testimonial.name}
                    </h4>
                    <p className="text-xs text-gray-500" data-id="element-411">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>

              <div className="absolute top-8 right-8 flex items-center text-[#4CAF50] text-xs font-bold bg-[#4CAF50]/10 px-2.5 py-1 rounded-full" data-id="element-412">
                <CheckCircle size={12} className="mr-1" data-id="element-413" /> Compra Verificada
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}